<template>
	<section class="sk">
		<aside class="sk__menu">
			<div class="sk__menu-wrapper">
				<router-view ref="menu" id="menu" name="menu"/>
			</div>
		</aside>
		<main class="sk__content">
			<router-view :user_uid="user_uid" id="content"/>
			<div style="clear:both; height: 50px;"></div>
		</main>
	</section>
</template>

<script>
export default {
	name: 'app-shell',
	props: [
		'user_uid'
	],
	data() {
		return {
			active: false,
			mediaQuery: null
		}
	},
	methods: {
	}
}
</script>

<style scope>
.sk {
	width: 100vw;
	height: 100vh;
	display: grid;
	grid-template-columns: 250px 1fr;
	max-width: 100vw;
}
.sk__menu {
	background-color: var(--main-color);
	overflow-y: auto;
	display: grid;
	grid-template-rows: var(--topbar-height) minmax(800px, 1fr);
}
.sk__menu-logo {
	background-color: var(--main-color-dark);
	width: 100%;
	height: 100%;
	background-image: url(/static/svg/logos/logo-white-inline.svg);
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
}
.sk__menu-wrapper {
	padding: 0;
}
.sk__content {
	background-color: #fff;
	padding: 40px;
	overflow: auto;
}
.sk__menu-action {
	display: none;
	position: fixed;
	height: 48px;
	width: 48px;
	bottom: 20px;
	right: 20px;
	/* left:  50%; */
	/* transform: translate(-50%, 0); */
	background-color: #333;
	border-radius: 100%;
	box-shadow: rgba(0,0,0,0.5) 0 0 10px;
	z-index: 2000;
}
.sk__menu-action > span {
	display: block;
	width: 100%;
	height: 100%;
	position: absolute;
	background-position: center;
	background-repeat: no-repeat;
	transition: opacity 0.3s;
}
.sk__menu-action > span:nth-child(1) {
	background-size: 24px;
	background-image: url(/static/svg/buttons/menu.svg);
	opacity: 1;
}
.sk__menu-action > span:nth-child(2) {
	background-size: 18px;
	background-image: url(/static/svg/buttons/close.svg);
	opacity: 0;
}
.sk__menu__bg {
	visibility: hidden;
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	background-color: rgba(0,0,0,0.5);
	opacity: 0;
	transition: visibility 0s 0.3s, opacity 0.3s 0s;
	z-index: 998;
}

@media screen and (max-width: 1025px) {
	.sk {
		grid-template-columns: 1fr;
		grid-template-rows: 1fr;
		overflow: hidden;
	}
	.sk__menu {
		order: 2;
		overflow: hidden;
	}
	.sk__content {
		order: 1;
		max-width: 100vw;
		padding: 0;
		overflow: hidden;
	}
	.sk__content > div {
		height: 100%;
		overflow: hidden;
	}
	.sk__content > div > .body {
		max-height: calc(100vh - 180px);
		overflow: auto;
		padding-bottom: 80px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/shell/AppShell.vue